export default class ServicesPresentation{ 
  servicesPresentation;
  handlers;
  expandedItemWidth;
  itemHeaderWidth = 90;
  constructor(servicesPresentation) {
    this.servicesPresentation = servicesPresentation;
    this.handlers = this.servicesPresentation.getElementsByClassName('services-presentation-item-handler');
    this.setItemsWidth();
    this.servicesPresentation.classList.add('initializated');
    this.bindListeners();
  }
  
  setItemsWidth = () => {
    let activeItem = this.servicesPresentation.querySelector('.services-presentation-item.active');
    let activeItemBody = activeItem.querySelector('.services-presentation-item-body');
    this.expandedItemWidth = this.servicesPresentation.clientWidth - (90 * 4);
    activeItemBody.style.width = this.expandedItemWidth + 'px';
    let items = this.servicesPresentation.getElementsByClassName('services-presentation-item-body-inner');
    for (let item of items) {
      item.style.width = this.expandedItemWidth + 'px';
    }
  }

  bindListeners = () => { 
    window.addEventListener('resize', this.setItemsWidth.bind(this));
    for (let handler of this.handlers) { 
      handler.addEventListener('click', this.activateItem.bind(this));
    }
  }

  activateItem = (ev) => {
    if (!ev.currentTarget.classList.contains('active')) { 
      let activeItem = this.servicesPresentation.querySelector('.services-presentation-item.active');
      let activeItemBody = activeItem.querySelector('.services-presentation-item-body');
      activeItem.classList.remove('active');
      activeItemBody.style.width = 0;
      ev.currentTarget.closest('.services-presentation-item').classList.add('active');
      ev.currentTarget.nextElementSibling.style.width = this.expandedItemWidth + 'px';
    }
  }


}


// WEBPACK FOOTER //
// ./ui/assets/js/ServicesPresentation/ServicesPresentation.js